import { render, staticRenderFns } from "./message-timestamp.vue?vue&type=template&id=d2baee44&scoped=true"
import script from "./message-timestamp.vue?vue&type=script&lang=ts"
export * from "./message-timestamp.vue?vue&type=script&lang=ts"
import style0 from "./message-timestamp.vue?vue&type=style&index=0&id=d2baee44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2baee44",
  null
  
)

export default component.exports